<template>
  <span :class="['out-of-stock', { 'out-of-stock--singlepage': singlepage }]">
    <span class="out-of-stock__icon">⚠</span> {{ $t('product_form.sold_out') }}
  </span>
</template>

<script>
export default {
  name: 'OutOfStock',
  props: {
    singlepage: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.out-of-stock {
  background-color: #fef0f0;
  font-size: 13px;
  padding: 10px 13px;
  border-radius: 4px;
  color: #555;
  display: inline-block;

  .out-of-stock__icon {
    font-size: 16px;
    color: black;
    font-weight: 200;
  }

  &--singlepage {
    color: #f08080;
    padding: 6px 10px;
    margin-top: 10px;
  }

  .out-of-stock__remove {
    text-decoration: underline;
    color: lightcoral;
  }
}
</style>
